import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const dashboardResponseSelector = createSelector(
  selector,
  (store) => {
    const { response } = store;
    if (!response) {
      return null;
    }

    return response;
  },
);

export const dashboardIsFetchingSelector = createSelector(
  selector,
  store => (store.isFetching),
);
